import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../../Shared/Services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import {
  SystemRoleUpdateResponse,
  SystemUserListResponse,
} from '../../../Interfaces/api/backoffice/user.interface';
import { TypedResourceRequest } from '../../Shared/Interfaces/api-request.interface';
import { SystemUser } from '../../../Models/backoffice/system-user.model';
import { SystemRole } from '../../../Enums/system-role.enum';

@Injectable({
  providedIn: 'root',
})
export class SystemUserService {
  private readonly _apiService = inject(ApiService);

  listRequest(): TypedResourceRequest<LaravelDefaultResponse<SystemUserListResponse>> {
    return this._apiService.get<LaravelDefaultResponse<SystemUserListResponse>>(
      endpoints.backoffice.systemUsers,
    );
  }

  countRequest(): TypedResourceRequest<LaravelDefaultResponse<SystemUserListResponse>> {
    return this._apiService.get<LaravelDefaultResponse<SystemUserListResponse>>(
      endpoints.backoffice.systemUsers,
      { skipLoading: true },
    );
  }

  toList(response: LaravelDefaultResponse<SystemUserListResponse> | undefined): SystemUser[] {
    return (response?.data?.users ?? []).map((row) => new SystemUser(row));
  }

  toTotal(response: LaravelDefaultResponse<SystemUserListResponse> | undefined): number {
    return response?.data?.total ?? 0;
  }

  updateSystemRole(
    userId: string,
    systemRole: SystemRole | null,
    force: boolean,
  ): Observable<SystemUser> {
    const request = this._apiService.put<LaravelDefaultResponse<SystemRoleUpdateResponse>>(
      endpoints.backoffice.userSystemRole(userId),
      { body: { system_role: systemRole, force }, skipError: true },
    );

    return this._apiService
      .run<LaravelDefaultResponse<SystemRoleUpdateResponse>>(request)
      .pipe(map((response) => new SystemUser(response.data.user)));
  }
}
